// // if not special case
// STANDARD

// // if giftcard
// GIFT_CARD_AND_MEMBERSHIP

// // if membership
// GIFT_CARD_AND_MEMBERSHIP

// // if Canada
// CANADIAN_AIR

// // if international (excluding canada)
// INTERNATIONAL_AIR


// Default shipping ID's for different types of items
// and ship-to locations. Everything domestic defaults to
// STANDARD as the shipping method, but there are some
// special cases where STANDARD does not apply. These are:
// - GiftCards or Memberships
// - Canadian shipments
// - International shipments

export default {
  isDefault: 'STANDARD',
  isGiftCard: 'GIFT_CARD_AND_MEMBERSHIP',
  isMembership: 'GIFT_CARD_AND_MEMBERSHIP',
  isCanadian: 'CANADIAN_AIR',
  isInternational: 'INTERNATIONAL_AIR',
}
